module.exports = __webpack_public_path__ + "static/media/locationOrange.2b928013.svg";